import React from "react";

interface Policy {
  id: number;
  title: string;
  file: string;
}

const PolicyCard = ({ id, title, file }: Policy) => {
  return (
    <a
      key={id}
      href={file}
      target="_blank"
      rel="noopener noreferrer"
      className="bg-white p-14 rounded-2xl shadow-lg border border-gray-200 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl cursor-pointer flex items-center justify-center text-left"
    >
      <p className="text-lg font-medium text-gray-800">{title}</p>
    </a>
  );
};

export default PolicyCard;
